import Vue from 'vue'
import Main from './main.vue'

let RetentionModalConstructor = Vue.extend(Main)

const RetentionModal = function (options, params) {
  let instance = new RetentionModalConstructor({
    ...options,
    data: {
      onClose: params?.onClose
    }
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.visible = true
  return instance
}

export default RetentionModal
